import $ from 'jquery'

export default {
    name: 'evenement',
    components: {
        
    },
    props: {
        user_id: Number,
        protocole_id: Number,
        hn: Number,
        evenements: Array,
        can_start_hn: Number
    },

    data() {
        return {
            is_loading: true,
            is_empty: false,

            evt_to_add: {},

            is_error: false,
            error_message: '',
            save_loading: false,
            del_loading: false,
            is_confirm: false,

            description: '',
            liste_evenements: [],

            data_to_delete: {}
        }
    },

    computed: {
        protocole_evenements() {
            return this.$store.getters['protocole_evenements'];
        },
    },

    mounted() {
        this.getEvenement()
    },

    methods: {
        addProtocoleData(data, data_id, protocole_id, hn) {
            this.evt_to_add = {
                data_id: data_id,
                data_type: data,
                libelle: 'Evènement',
                protocole_id: protocole_id,
                hn: hn
            }
        },

        refreshEvenement() {
            this.is_loading = true

            const data = {
                data_type: 'evenement',
                protocole_id: this.protocole_id,
                hn: this.hn
            }

            this.$store.dispatch('getProtocoleData', data).then(() => {
                this.liste_evenements = this.protocole_evenements

                if (this.liste_evenements.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }

                this.is_loading = false
            })
        },
        
        getEvenement() {
            this.is_loading = true

            this.liste_evenements = this.evenements
            if (this.liste_evenements.length == 0) {
                this.is_empty = true
            } else {
                this.is_empty = false
            }
            setTimeout(() => {
                this.is_loading = false
            }, 1000);
        },

        async submitEvent() {
            const isValid = await this.$refs.pev_form.validate();

            if (!isValid) {
                return;
            }

            const data = {
                data_id: this.evt_to_add.data_id,
                data_type: 'evenement',
                user_id: this.user_id,
                protocole_id: this.evt_to_add.protocole_id,
                hn: this.evt_to_add.hn,
                description: this.description
            }
            this.save_loading = true

            this.$store.dispatch('saveProtocoleData', data).then((response) => {
                if (response.success) {
                    this.successToast('Enregistrement effectué avec succès')

                    this.refreshEvenement()
                   
                    this.description = ''
                    this.$refs.pev_form.reset()
                    this.$refs.mng_ev.click()
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading = false
            })
        },

        setDataToDelete(evenement) {
            this.data_to_delete = {
                user_id: this.user_id,
                protocole_id: this.protocole_id,
                id: evenement.id
            }
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		/**
		 * Supprimer une CAT/Consigne
		 */
        deleteEvenement(selector) {
            const confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }


            this.del_loading = true
            
            this.$store.dispatch('deleteProtocoleData', this.data_to_delete).then((response) => {
                if (response.success) {
                    this.successToast('Suppression effectuée avec succès')
                    this.refreshEvenement()

                    this.$refs.del_evt.click()
                    this.is_error = false
                } else {
                    this.is_error = true
                    if (response.code === 401) {
                        this.error_message = "Impossible d'effectuer cette opération !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                
                this.del_loading = false;
                this.is_confirm = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },
    }
}


